import { render } from "./ToolBarBulk.vue?vue&type=template&id=6c52c42a"
import script from "./ToolBarBulk.vue?vue&type=script&lang=js"
export * from "./ToolBarBulk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__